import { useEffect } from 'react';
import { issueClient } from 'shared/domain/issue/issueClient';

/** Asks the worker to sync the issues once, when the view opens. */
export function useSyncIssuesOnMount(): void {
  useEffect(() => {
    issueClient.sync();
  }, []);
}
